import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as FindBookkeeperLogo } from '../../../assets/images/integrations/find-bookkeeper.svg'
import { useEmberTransitionTo } from '../../../hooks/routing/useEmberTransitionTo'
import { useOrganizationViewUrl } from '../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../utils/routing/reactRoute'
import { useOrganizationBookkeepers } from '../../settings/routes/OrganizationSettingsUsers/hooks/useOrganizationBookkeepers'
import { IntegrationId } from '../enums/integrationId'
import { IntegrationItem } from '../types/integrationItem'

export const useFindBookkeeperIntegration = (): IntegrationItem => {
  const { t } = useTranslation()
  const { transitionTo } = useEmberTransitionTo()
  const { data: bookkeepers, isLoading: isOrganizationBookkeepersLoading } = useOrganizationBookkeepers()

  const findAccountantRoute = reactRoute.organization.findAccountant.getMainRoute()
  const { url: findAccountantUrl } = useOrganizationViewUrl(findAccountantRoute)

  const hasOrganizationBookkeepers = bookkeepers?.length !== 0

  const buttonHandler = useCallback(() => {
    if (findAccountantUrl) {
      transitionTo(findAccountantUrl)
    }
  }, [transitionTo, findAccountantUrl])

  return {
    id: IntegrationId.FindBookkeeper,
    name: t('integrations.card.find_bookkeeper.title'),
    description: t('integrations.card.find_bookkeeper.body'),
    readMoreLink: 'https://www.billy.dk/revisor/find-selv-revisor/',
    imageNode: <FindBookkeeperLogo />,
    isHiddenLoading: isOrganizationBookkeepersLoading,
    isHidden: hasOrganizationBookkeepers,
    buttonHandler,
    buttonText: t('integrations.card.find_bookkeeper.button.activate'),
    statusLabelNode: null,
    isStatusLoading: false,
  }
}
